import React, { useState } from 'react'
import { useAuthContext } from './reducer'
import styled from '@emotion/styled'
import { gsColors } from '../../styles/Variables'
import { Text } from '../../styles/Components'
import Button from '../../components/Button'
import { loginWithToken } from '../../services/Authenticator'
import { useUserContext } from '../../components/UserContext'
import { segmentEvent, classifyAuthError, getAuthErrorMessage } from '../../helpers'
import LoadingDot from '../book/steps/components/LoadingDot'
import Error from './Error'

const TokenSelectorWrappr = styled.div`
  display: flex;
  justify-content: center;

  .token-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    max-width: 350px;
  }
`

const TokenButton = styled.button`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  background-color: transparent;
  border-radius: 4px;
  border: 1px solid ${gsColors.lightTangerine};
  padding: 20px 24px;
  box-sizing: border-box;
  // width: 350px;
  gap: 4px;

  &.active {
    border: 2px solid ${gsColors.cobalt};
  }

  p {
    text-align: left;
  }
`

export const TokenSelector = ({ onSuccess }) => {
  const { state, dispatch } = useAuthContext()
  const { setUser } = useUserContext()
  const [working, setWorking] = useState(false)

  if (!state.accessTokens || !state.accessTokens.length) {
    return null
  }

  const handleSelect = (token) => {
    dispatch({
      type: 'SET_SELECTED_ACCESS_TOKEN',
      token
    })
  }

  const handleLogin = () => {
    setWorking(true)
    // clear any prior error so a retry starts clean
    dispatch({ type: 'SET_SUBMIT_ERROR', error: null })
    setTimeout(async () => {
      // 'Account Selected' is the selection intent; the login that follows may still fail —
      // wrap it so a failure is tracked (previously an unhandled rejection) and never
      // reported as a success.
      segmentEvent('Account Selected', { type: state.otpChannel })
      try {
        const user = await loginWithToken(state.selectedAccessToken)
        setUser(user)
        onSuccess()
      } catch (e) {
        segmentEvent('Account Selection Failed', { type: state.otpChannel, errorType: classifyAuthError(e), message: getAuthErrorMessage(e) })
        // surface the failure so the user isn't stranded with a silent no-op (this login only
        // realistically fails on a network error fetching the user after selecting an account)
        dispatch({ type: 'SET_SUBMIT_ERROR', error: e })
      } finally {
        setWorking(false)
      }
    }, 300)
  }

  return (
    <TokenSelectorWrappr>
      <div className='token-content'>
        {state.accessTokens.map((token, index) => (
          <TokenButton
            key={index}
            onClick={() => handleSelect(token.access_token)}
            className={state.selectedAccessToken === token.access_token ? 'active' : ''}
          >
            <Text
              weight={600}
            >
              {token.name}
            </Text>
            <Text
              weight={600}
              fontSize={13}
              color={gsColors.textGrey}
            >
              {token.email}
            </Text>
          </TokenButton>
        ))}

        <Button
          margin="45px 0 0"
          large
          fill='true'
          type="button"
          color={gsColors.cobalt}
          disabled={!state.selectedAccessToken || working}
          onClick={handleLogin}
        >
          { working ? (
            <LoadingDot color='#fff' />
          ) : 'Continue' }
        </Button>

        <div style={{ textAlign: 'center' }}>
          <Error error={state.submitError} />
        </div>
      </div>
    </TokenSelectorWrappr>
  )
}
